import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EthosV2ReaderForm from '../forms/ethos-v2-reader-form';
import { ethosV2ReaderValidationSchema } from '../schema/ethosV2Reader.js';

export default function EthosV2ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Ethos V2 Reader Node Details',
        altText: 'Ethos V2 Reader Node',
        defaultLabel: 'Ethos V2 Reader Node',
      }}
    >
      <CommonNode
        FormComponent={EthosV2ReaderForm}
        schemaResolver={ethosV2ReaderValidationSchema}
      />
    </NodeProvider>
  );
}
